<ejs-dialog #editProductAssetDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()"
  (open)="onOpen($event)">
  <ng-template #header>
    {{'i18n.domain.assets.brand-logos.delete-dialog.title' | translate}}
  </ng-template>

  <ng-template #content>
    <div class="row form-group marginTop">
      <div class="col-3">
        <label class="control-label mr-2 toggle-label">{{ 'i18n.domain.assets.brand-logos.delete-dialog.delete-all-product-logos' | translate }}</label>
      </div>
      <div class="col-3">
        <ejs-switch #deleteAllProductLogosSwitch [checked]="deleteAllProductLogos" (change)="deleteAllProductLogosSwitched()"></ejs-switch>
        <ejs-tooltip id='tooltip1' class="ml-2 toggle-label" content="{{'i18n.domain.assets.brand-logos.delete-dialog.delete-all-product-logos-details' | translate}}" target="#target1">
          <span id="target1" class="e-icons icon-help detail-icon"></span>
        </ejs-tooltip>
      </div>
    </div>
    <div class="row form-group" [hidden]="isBrandLogo">
      <div class="col-3">
        <label class="control-label mr-2 toggle-label">{{ 'i18n.domain.assets.brand-logos.delete-dialog.reapply-product-logos' | translate }}</label>
      </div>
      <div class="col-3">
        <ejs-switch #reapplyProductLogosSwitch [checked]="reapplyProductLogos" (change)="reapplyProductLogosSwitched()"></ejs-switch>
        <ejs-tooltip id='tooltip2' class="ml-2 toggle-label" content="{{'i18n.domain.assets.brand-logos.delete-dialog.reapply-product-logos-details' | translate}}" target="#target2">
          <span id="target2" class="e-icons icon-help detail-icon"></span>
        </ejs-tooltip>
      </div>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat"
              (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-primary e-flat"
              (click)="onDelete()">
        @if (isLoading) {
          <div class="spinner-border spinner-border-sm me-3" role="status"></div>
        }
        {{'i18n.shared.delete' | translate}}
      </button>
    </ng-container>
  </ng-template>
</ejs-dialog>
